module.exports = __webpack_public_path__ + "img/1074722c095c5d6c66ce6235a56cb4b1.19d6e974.jpg";